<template>
    <div v-if="showModal">
        <div :class="{ 'modal-vue--hide-nav': hideNav}" class="modal-vue--overlay d-flex" :style="{ 'z-index': zIndex }" @click="cancelModal()">
            <div class="modal-vue mx-auto my-auto" :class="[{ 'modal-vue--radius-top-6': roundedTop, 'modal-vue--large-modal': MobileFull  }, widthClass]" @click.stop>
                <div class="modal-vue__top" v-if="useModalTemplate">
                    <span class="modal-vue__top--title" v-text="title"></span>
                </div>
                <div v-if="content" class="modal-vue__content" :class="{ 'modal-vue__content--negative-margin': contentNoPadding }" v-html="content"></div>
                <div v-else class="modal-vue__content" :class="{ 'modal-vue__content--negative-margin': contentNoPadding }">
                    <slot v-bind="{ closeModal }"></slot>
                </div>
                <div class="modal-vue__bottom" v-if="useModalTemplate">
                    <div class="w-100 d-flex align-items-center py-3" :class="centerButtons? 'justify-content-around' : 'justify-content-between'">
                        <button v-for="button in buttons"
                                class="button button--clear m-0"
                                :class="button.class"
                                v-on:click="$emit(button.emit_name)"
                                v-text="button.text"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "ModalVue",
        props: {
            isMobile: Boolean,
            title: String,
            width: String, // **** xs sm md lg xl ****
            cancelIfClickedOutsideModal: {
                type: Boolean,
                default: true
            },
            hideNav: {
                type: Boolean,
                default: false,
                required: false
            },
            roundedTop: {
                type: Boolean,
                default: false,
                required: false
            },
            MobileFull: {
                type: Boolean,
                default: false,
                required: false
            },
            useModalTemplate: {
                type: Boolean,
                default: true
            },
            show: {
                type: Boolean,
                default: false
            },
            buttons: {
                type: Array,
                default: function () { return [] }
            },
            content: {
                type: String,
                required: false
            },
            centerButtons: {
                type: Boolean,
                default: false,
                required: false
            },
            zIndex: {
                type: Number,
                required: false,
                default: 3,
            },
            contentNoPadding: {
                type: Boolean,
                required: false,
                default: false,
            },
            globalEmitTriggerName: {
                type: String,
                required: false,
                default: null,
            }
        },
        data() {
            return {
                count: 0,
                widthClass: '',
                showModal: false,
            }
        },
        methods: {
            cancelModal() {
                if (this.cancelIfClickedOutsideModal) {
                    document.body.classList.remove("modal-vue--open");
                    this.$emit('cancel');
                    this.$emit('close');
                }
            },
            modalSize(width) {
                if(!this.useModalTemplate){
                    this.widthClass = 'py-0'
                }
                this.widthClass = this.widthClass + ' modal-vue__width--' + width;
            },
            closeModal(){
                this.showModal = false;
            },
            openModal(){
                this.showModal = true;
            }
        },
        watch: {
            show(newValue){
                this.showModal = newValue;
            }
        },
        mounted() {
            this.modalSize(this.width);
            this.showModal = this.show || false;

            if (this.globalEmitTriggerName) {
                window.EventBus.$on(this.globalEmitTriggerName, () => this.openModal());
            }
        }
    }
</script>
